export default "__VITE_ASSET__WJRxdlcW__"